import { DigitalFootprintConfig } from '../brand.interface';

/**
 * DeleteMe Digital Footprint Categories (12 categories)
 * Full comprehensive analysis for privacy assessment
 */
export const deletemeDigitalFootprint: DigitalFootprintConfig = {
  categories: [
    {
      key: 'ThreatMitigation',
      title: 'Threat Mitigation',
      description:
        'This score reflects the ability to manage and limit threats against personal information. A lower value indicates better defense mechanisms in place to thwart potential breaches.',
    },
    {
      key: 'DataSensitivityAwareness',
      title: 'Data Sensitivity Awareness',
      description:
        'Indicates the understanding of what constitutes sensitive data and the importance of protecting it. A high score suggests that personal data is managed accordingly, while a low score suggests a lack of awareness.',
    },
    {
      key: 'ResponseEfficiency',
      title: 'Response Efficiency',
      description:
        'Measures the effectiveness and speed in responding to data breaches or cyber threats. Higher scores imply longer response times or unaddressed breaches.',
    },
    {
      key: 'PrivacyCompliance',
      title: 'Privacy Compliance',
      description:
        'Evaluates adherence to data privacy laws and regulations. A high score suggests a trajectory towards compliance but could still be vulnerable.',
    },
    {
      key: 'Trustworthiness',
      title: 'Trustworthiness',
      description:
        "Assesses the perceived reliability and security of the individual's data handling. A higher score speaks to significant data exposure or lack of protections.",
    },
    {
      key: 'PreventativeMonitoring',
      title: 'Preventative Monitoring',
      description:
        'Relates to the active monitoring of personal data for unauthorized access or breaches. High scores signify little to no monitoring, which can lead to higher risks.',
    },
    {
      key: 'UserEducationAndAwareness',
      title: 'User Education and Awareness',
      description:
        'Reflects the level of understanding and education on maintaining privacy and cybersecurity. Higher scores indicate a greater need for improved education.',
    },
    {
      key: 'ReputationManagement',
      title: 'Reputation Management',
      description:
        'Assesses the ability to control personal brand perception online. A higher score may indicate reputational risks arising from public visibility.',
    },
    {
      key: 'DataIntegrity',
      title: 'Data Integrity',
      description:
        'Relates to the accuracy and reliability of personal data. A lower score suggests potential issues with data reliability which could influence decisions.',
    },
    {
      key: 'ProfessionalCompetence',
      title: 'Professional Competence',
      description:
        'Evaluates the skills and qualifications related to managing cybersecurity. A high score indicates gaps in skills that can lead to vulnerabilities.',
    },
    {
      key: 'PublicVisibility',
      title: 'Public Visibility',
      description:
        "This illustrates how exposed an individual's personal information is online. A higher score signifies greater public visibility, raising risks of malicious activities.",
    },
    {
      key: 'DigitalFootprint',
      title: 'Digital Footprint',
      description:
        'Measures the amount of information about an individual available online. High scores point to significant risks tied to personal information being widely accessible.',
    },
  ],
};
